import service from './api.service';

class TranslateService {
  static readonly translateText = (data: any): Promise<any> => {
    return service.post('traducao/traduzir', data);
  }
}

export default TranslateService;
